import { useGetResources } from '@hooks/useGetResources';

import { LinkList } from '@helsenorge/designsystem-react/components/LinkList';
import Title from '@helsenorge/designsystem-react/components/Title';

export const AboutVerktoy = (): React.JSX.Element => {
  const resources = useGetResources();

  return (
    <div className="entryPage__sectionMargin">
      <Title appearance="title2" htmlMarkup="h2">
        {resources?.entryPage_aboutVerktoy_title}
      </Title>
      <LinkList className="entryPage__elementMargin_top" chevron variant="line" color="white" size="medium">
        <LinkList.Link href={resources?.entryPage_aboutVerktoy_linkHref}>{resources?.entryPage_aboutVerktoy_linkText}</LinkList.Link>
      </LinkList>
    </div>
  );
};
